import { EINREICHUNG_STORE_KEY } from '../reducers';
import { EinreichungState } from '../reducers/einreichung.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const getEinreichungState = createFeatureSelector<EinreichungState>(EINREICHUNG_STORE_KEY);
export const selectContainers = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.containersList.data,
);
export const selectContainersLoading = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.containersList.loading,
);
export const selectContainersError = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.containersList.error,
);
